export default __webpack_public_path__ + "static/download-square-9b4c0f32aab9aa4e598db91a1eb47a9c.jpg";